import { AuthenticationService } from '../services/authenticationService';

export function appInitializer(authenticationService: AuthenticationService) {
    return () => new Promise<void>(resolve => {
        resolve(authenticationService.checklogin());
    });
}
